import { createFileRoute } from '@tanstack/react-router';
import { LostListPage } from '../../../features/crm';
import { usePageTitle } from '../../../lib/hooks';

export const Route = createFileRoute('/_auth/crm/lost')({
  component: LostRoute,
});

function LostRoute() {
  usePageTitle('Lost Contacts');
  return <LostListPage />;
}
